import { render, staticRenderFns } from "./PopulationAgeChart.vue?vue&type=template&id=73657a40"
import script from "./PopulationAgeChart.vue?vue&type=script&lang=js"
export * from "./PopulationAgeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports